<template>
    <div class="shipping-container">
        <p class="shipping-title">Shipping</p>
        <div class="shipping-tipbar">Shipping Address</div>
        <div class="shipping-address-items">
            <div
                class="shipping-address-item"
                :class="{ error: hasAddress }"
                v-if="Object.keys(address).length == 0"
            >
                <p class="shipping-address-item-placeholder">
                    Please add shipping address
                </p>
                <el-button type="primary" size="mini" @click="add"
                    >ADD</el-button
                >
            </div>
            <div
                class="shipping-address-item"
                v-else
                v-loading="addressLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
            >
                <p class="shipping-address-item-label" style="font-weight: 600">
                    {{ address.name }}
                </p>
                <p class="shipping-address-item-label">
                    {{ address.street1 + address.street2 }}
                </p>
                <p class="shipping-address-item-label">
                    {{
                        address.city +
                        " " +
                        address.state +
                        " " +
                        address.postal_code
                    }}
                </p>
                <p class="shipping-address-item-label">
                    {{ address.country_name }}
                </p>
                <p class="shipping-address-item-label">{{ address.phone }}</p>
                <el-button type="primary" size="mini" @click="replace"
                    >REPLACE</el-button
                >
            </div>
        </div>
        <template v-if="shippingMethodList.length > 0">
            <div class="shipping-tipbar">Shipping Methods</div>
            <div
                class="shipping-methods"
                :class="{ error: shippingMethodIsRequired }"
            >
                <div
                    class="shipping-methods-item"
                    v-for="item of shippingMethodList"
                    :key="item.id"
                >
                    <el-radio
                        v-model="channelCode"
                        :label="item.last_mile && item.last_mile.last_mile || ''"
                        @change="channelCodeChange(item)"
                    >
                        <span class="shipping-methods-price">{{
                            item.currency.symbol + item.price
                        }}</span>
                        <span class="shipping-methods-name">{{
                            item.last_mile && item.last_mile.last_mile || ''
                        }}</span>
                        <span>{{ item.delivery }}</span>
                    </el-radio>
                </div>
            </div>
        </template>
        <template v-if="iossList.length > 0">
            <div class="ioss-tipbar">IOSS</div>
            <div class="ioss-list" :class="{ error: iossIsRequired }">
                <div
                    class="ioss-list-item"
                    v-for="item of iossList"
                    :key="item.id"
                >
                    <el-radio
                        v-model="ioss"
                        :label="item.ioss"
                        @change="iossChange(item)"
                    >
                        <span
                            class="ioss-list-name"
                            v-if="item.ioss.includes('Declare with CMOffer')"
                            >{{ item.ioss }}
                            <span style="margin: 0 0 0 5px">$2</span></span
                        >
                        <span class="ioss-list-name" v-else>{{
                            item.ioss
                        }}</span>
                    </el-radio>
                </div>
            </div>
        </template>
        <template v-if="couponList.length > 0">
            <div class="coupon-tipbar">Coupon</div>
            <div class="coupon-list">
                <div
                    class="coupon-list-item"
                    v-for="item of couponList"
                    :key="item.id"
                >
                    <el-radio
                        v-model="userCouponId"
                        :label="item.user_coupon_id"
                        @change="couponChange(item)"
                    >
                        <el-tooltip
                            effect="dark"
                            :content="item.name"
                            placement="top-start"
                        >
                            <span class="coupon-list-name">{{
                                item.name
                            }}</span>
                        </el-tooltip>
                        <span class="coupon-list-price">{{
                            item.value + "%"
                        }}</span>
                    </el-radio>
                </div>
            </div>
        </template>
        <template v-if="insure_fee > 0">
            <div class="insure-tipbar">
                Insure
                <el-tooltip
                    effect="dark"
                    content="Pay a $15 premium for coverage up to $1,500"
                    placement="top-start"
                    popper-class="insure_tooltip"
                >
                    <i class="el-icon-warning-outline"></i>
                </el-tooltip>
            </div>
            <div class="insure-list">
                <el-checkbox
                    v-model="insure"
                    :true-label="insure_fee"
                    :false-label="0"
                    >${{ insure_fee }}</el-checkbox
                >
            </div>
        </template>
        <div class="table-wrapper">
            <el-table
                ref="shippingTable"
                :data="tableData"
                :cell-style="cellStyle"
                style="width: 100%"
                header-cell-class-name="header-cell-class-name"
                cell-class-name="cell-class-name"
            >
                <el-table-column label="Item" width="550">
                    <template slot-scope="scope">
                        <div class="goods-info-wrapper">
                            <el-image
                                v-if="scope.row.image"
                                :src="scope.row.image"
                                :preview-src-list="[scope.row.image]"
                                fit="contain"
                                :lazy="true"
                            ></el-image>
                            <div class="info-wrapper">
                                <div class="goods-name ellipsis-2">
                                    {{ scope.row.goods_name }}
                                </div>
                                <div class="sku">
                                    <span>SKU:</span> {{ scope.row.sku }}
                                </div>
                                <div class="attr-value">
                                    {{ scope.row.attr_value }}
                                </div>
                                <template v-if="scope.row.array_mul == 1">
                                <div
                                    class="goods-attribute"
                                    v-for="item of Object.entries(
                                        scope.row.custom_properties
                                    )"
                                    :key="item[0]"
                                >
                                    <p class="goods-attribute-label">
                                        {{ item[0] }}:
                                    </p>
                                    <template v-if="!isImlUrl(item[1])">
                                        <el-tooltip
                                            v-if="item[1].length > 40"
                                            :content="item[1]"
                                            placement="top"
                                        >
                                            <p
                                                class="
                                                    goods-attribute-value
                                                    ellipsis
                                                "
                                                v-html="
                                                    item[1].replaceAll
                                                        ? item[1].split('\n').join('<br />')
                                                        : item[1]
                                                "
                                            ></p>
                                        </el-tooltip>
                                        <p
                                            v-else
                                            class="goods-attribute-value"
                                            v-html="
                                                item[1].replaceAll
                                                    ? item[1].split('\n').join('<br />')
                                                    : item[1]
                                            "
                                        ></p>
                                    </template>
                                    <!-- Photo -->
                                    <div class="photo_set" v-else>
                                        <el-image
                                            v-for="item of item[1].split(',')"
                                            :key="item"
                                            :src="item"
                                            fit="contain"
                                            :lazy="true"
                                        ></el-image>
                                    </div>
                                </div>
                                </template>
                                <template v-if="scope.row.array_mul == 2">
                                    <div
                                        v-for="(item,index) in scope.row.custom_properties"
                                        :key="index"
                                    >
                                        
                                            <div v-if="item.custom" style="padding:2px 10px;background-color:rgb(238, 242, 254);">Custom {{index+1}}</div>
                                            <div v-for="(v,k) in item.custom" :key="k"  style="padding: 5px 0 0 10px;">
                                                <div v-if="isAnImage(v)">
                                                    {{k}} : <el-image
                                                        :src="ossImg(v, 80, 80)"
                                                        :preview-src-list="[ossImg(v, 800, 800)]"
                                                        fit="contain"
                                                        :lazy="true"
                                                    ></el-image>
                                                </div>
                                                <div v-else>{{k}} : {{v}}</div>
                                            </div>
                                        
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Price">
                    <template slot-scope="scope"
                        >${{ scope.row.goods_price }}</template
                    >
                </el-table-column>
                <el-table-column
                    label="Quantity"
                    prop="goods_num"
                ></el-table-column>
                <el-table-column label="Subtotal">
                    <template slot-scope="scope"
                        >${{
                            (
                                scope.row.goods_price * scope.row.goods_num
                            ).toFixed(2)
                        }}</template
                    >
                </el-table-column>
            </el-table>
        </div>
        <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 10 }"
            placeholder="If you have special requirements for the order, Please leave a message."
            v-model="remark"
        ></el-input>
        <div class="bottom-bar">
            <div class="discount" v-show="discount">
                <p class="discount-label">Discount</p>
                <p class="discount-value">{{ +discount >= 1 && `${discount}% off` || '-$' + discount.toFixed(2) }}</p>
            </div>
            <div class="subtotal">
                <p class="subtotal-label">Subtotal</p>
                <p class="subtotal-value">${{ subtotal.toFixed(2) }}</p>
            </div>
            <div class="total">
                <p class="total-label">Total</p>
                <p class="total-value">${{ total }}</p>
            </div>
            <div class="checkout-btn" @click="placeOrder">
                <el-button>Place Order</el-button>
            </div>
        </div>
        <add :addVisible.sync="addVisible" funcName="replace"></add>
        <edit
            :editVisible.sync="editVisible"
            funcName="replace"
            :tableItem="tableItem"
        ></edit>
        <addressList
            :isShowUse="true"
            :listVisible.sync="listVisible"
            @replaceAddress="replaceAddress"
            @editAddress="editAddress"
        ></addressList>
    </div>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import add from "./shippingAdmin/add.vue";
import edit from "./shippingAdmin/edit.vue";
import addressList from "./shippingAdmin/addressList.vue";
import { mapState } from "vuex";

export default {
    data() {
        return {
            channelCode: "",
            shipCost: "",
            addVisible: false,
            editVisible: false,
            listVisible: false,
            hasAddress: false,
            addressLoading: false,
            tableData: [],
            address: {},
            remark: "",
            shippingMethodList: [],
            shippingMethodIsRequired: false,
            iossIsRequired: false,
            country_id: "",
            orderData: [],
            orderInfo: {},
            subtotal: 0,
            orderAmount: 0,
            discount: 0,
            weight: 0,
            iossList: [],
            ioss: "",
            iossFee: 0,
            couponList: [],
            userCouponId: 0,
            insure: 0,
            insure_fee: 0,
        };
    },
    computed: {
        height() {
            return `calc(100% - 200px)`;
        },
        ...mapState({
            userInfo: (state) => state.login.userInfo,
            cartNum: (state) => state.login.cartNum,
            addedCartNum: (state) => state.login.addedCartNum,
        }),
        total() {
            return (
                this.orderAmount * (+this.discount >= 1 && (100 - +this.discount)/100 || 1) +
                +this.iossFee +
                +this.shipCost +
                +this.insure
            ).toFixed(2);
        },
    },
    components: {
        add,
        edit,
        addressList,
    },
    watch: {
        address: {
            handler(val) {
                if (Object.keys(val).length != 0) {
                    this.hasAddress = false;
                    // this.getShippingMethod();
                    this.orderPlaceInfo();
                }
            },
            deep: true,
        },
        insure_fee(val) {
            console.log("insure_fee: ", val);
            // 默认不勾选
            this.insure = 0;
        },
    },
    methods: {
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 2 || columnIndex == 4) {
                return { color: "#9b3c44" };
            }
        },
        add() {
            this.addVisible = true;
        },
        replace() {
            this.listVisible = true;
        },
        editAddress(row) {
            this.editVisible = true;
            this.tableItem = row;
        },
        isAnImage(filePath){
            //获取最后一个.的位置
            var index= filePath.lastIndexOf(".");
            //获取后缀
            var ext = filePath.substr(index+1)
            return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1;
        },
        replaceAddress(row) {
            this.country_id = row.country;
            this.address = { ...row, country: row.country_name };
            // this.iossSelect();
            this.orderPlaceInfo();
            // 重置物流和ioss验证
            this.channelCode = null;
            this.shippingMethodIsRequired = false;
            if (this.iossList && this.iossList.length > 0) {
                this.ioss = null;
                this.iossIsRequired = false;
            }
        },
        defaultUserAddress() {
            return new Promise((resolve, reject) => {
                cmofferApi.userAddress({ default: 1 }, "get").then((res) => {
                    if (res) {
                        if (res.data.length > 0) {
                            let data = res.data[0];
                            this.address = {
                                name: data.name,
                                street1: data.street1,
                                street2: data.street2,
                                city: data.city,
                                state: data.state,
                                postal_code: data.postal_code,
                                country: data.country_name,
                                country_id: data.country,
                                country_name: data.country_name,
                                phone: data.phone,
                            };
                            this.country_id = data.country;
                            resolve();
                            // this.getShippingMethod();
                            // this.iossSelect();
                        }
                    }
                });
            });
        },
        async initialize() {
            this.tableData = [];
            this.orderData = JSON.parse(sessionStorage.getItem("ORDERDATA"));
            this.orderInfo = JSON.parse(sessionStorage.getItem("ORDERINFO"));
            this.subtotal = this.orderInfo.subtotal;
            this.orderAmount = this.orderInfo.orderAmount;
            this.discount = this.orderInfo.discount;
            this.weight = this.orderInfo.weight;
            for (var i in this.orderData) {
                // 转换key名
                let dutyTypeJson = JSON.stringify(this.orderData[i]);
                let dutyTypes = JSON.parse(
                    dutyTypeJson
                        .replace(/qty/g, "goods_num")
                        .replace(/price/g, "goods_price")
                        .replace(/discount/g, "goods_discount")
                        .replace(/custom_json/g, "custom_properties")
                );
                this.orderData[i] = dutyTypes;
                this.tableData.push(this.orderData[i]);
            }
            await this.defaultUserAddress();
        },
        placeOrder() {
            if (Object.keys(this.address).length == 0) {
                this.hasAddress = true;
                return;
            }
            if (!this.channelCode) {
                this.shippingMethodIsRequired = true;
                return;
            }
            if (!this.ioss && this.iossList && this.iossList.length > 0) {
                this.iossIsRequired = true;
                return;
            }
            if (Object.keys(this.tableData).length == 0) {
                this.$router.replace({
                    path: "/shoppingCart",
                });
                this.$message.warning("Please select an item");
                return;
            }
            cmofferApi
                .placeOrder(
                    {
                        platform_id: 5,
                        shop_id: 0,
                        shop_name: "",
                        plt_order_sn: "",
                        plt_order_id: "",
                        country: this.address.country_name,
                        plt_create_time: this.$moment().format(
                            "YYYY-MM-DD HH:mm:ss"
                        ),
                        order_amount: this.total,
                        discount: this.discount,
                        ship_cost: this.shipCost,
                        taxes: 0,
                        currency: "USD",
                        payment_time: "",
                        shiped_time: "",
                        payment_method: "",
                        pay_code: "",
                        last_mile: this.channelCode,
                        express_name: "",
                        tracking_number: "",
                        remark: this.remark,
                        customer_email: "",
                        orders_address: {
                            ...this.address,
                            buyer_name: this.address.name,
                        },
                        orders_goods: this.tableData,
                        ioss: this.ioss,
                        ioss_fee: this.iossFee,
                        user_coupon_id: this.userCouponId,
                        insure_fee: this.insure && this.insure_fee,
                    },
                    "post"
                )
                .then((res) => {
                    if (res) {
                        this.$message.success(
                            `${this.$i18n.locale == "zh" ? "成功" : "Success"}`
                        );
                        this.orderInfo.discount = +this.discount;
                        this.orderInfo.shipping = +this.shipCost;
                        this.orderInfo.orderAmount = +this.total;
                        this.orderInfo.iossFee = +this.iossFee;
                        this.orderInfo.insureFee = +this.insure;
                        this.$store.commit("SETORDERINFO", this.orderInfo);
                        this.$store.commit("SETORDERDATA", this.orderData);
                        this.$router.replace({
                            path: "/payment",
                            query: {
                                order_sn: res.order_sn,
                                orderId: res.id,
                            },
                        });
                        // 减去已下单的产品数量
                        !this.cartNum &&
                            this.$store.commit(
                                "SETCARTNUM",
                                sessionStorage.getItem("CARTNUM")
                            );
                        !this.addedCartNum &&
                            this.$store.commit(
                                "SETADDEDCARTNUM",
                                sessionStorage.getItem("ADDEDCARTNUM")
                            );
                        this.$store.commit(
                            "SETCARTNUM",
                            this.cartNum - this.addedCartNum
                        );
                        this.resetVariable();
                    }
                });
        },
        getShippingMethod() {
            cmofferApi
                .shippingMethod({
                    country_id: this.country_id,
                    weight: this.weight,
                })
                .then((res) => {
                    // console.log("res: ", res);
                    if (res) {
                        this.shippingMethodList = res.data;
                    }
                });
        },
        channelCodeChange(val) {
            this.shipCost = val.price;
            this.shippingMethodIsRequired = false;
            this.userCouponId = 0;
            this.discount = 0;
            // this.couponSelect();
            //this.orderPlaceInfo();
        },
        iossChange(val) {
            // 选择我们的ioss, 金额需加2
            if (val.ioss === "Declare with CMOffer's IOSS") {
                this.iossFee = 2;
            } else {
                this.iossFee = 0;
            }
            this.iossIsRequired = false;
        },
        iossSelect() {
            cmofferApi
                .iossSelect({ country: this.address.country_name }, "get")
                .then((res) => {
                    // if (res) {
                    if (res.errcode == 0) {
                        this.iossList = res.data || [];
                        this.iossFee = 0;
                        this.ioss = "";
                        this.iossIsRequired = false;
                    }
                    // }
                });
        },
        resetVariable() {
            this.remark = "";
            this.channelCode = "";
            this.ioss = "";
        },
        couponSelect() {
            cmofferApi
                .couponSelect(
                    {
                        amount:
                            this.orderAmount + this.iossFee + +this.shipCost,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.couponList = res.data;
                        if (this.couponList.length > 0) {
                            this.couponList.push({
                                name: "Do not use",
                                user_coupon_id: 0,
                                value: 0,
                            });
                        }
                    }
                });
        },
        couponChange(coupon) {
            this.discount = coupon.value;
            this.userCouponId = coupon.user_coupon_id;
        },
        orderPlaceInfo() {
            cmofferApi
                .orderPlaceInfo(
                    {
                        country_id: this.country_id,
                        amount:
                            this.orderAmount + this.iossFee + +this.shipCost,
                        weight: this.weight.toFixed(2),
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        console.log(res);
                        let { shipping, ioss, coupon, insure_fee } = res.data;
                        // 物流
                        this.shippingMethodList = shipping;
                        // ioss
                        this.iossList = ioss;
                        this.iossFee = 0;
                        this.ioss = "";
                        this.iossIsRequired = false;
                        // 优惠劵
                        this.couponList = coupon;
                        this.couponList.length > 0 &&
                            this.couponList.push({
                                name: "Do not use",
                                user_coupon_id: 0,
                                value: 0,
                            });
                        // 保险
                        this.insure_fee = insure_fee;
                    }
                });
        },
    },
    activated() {
        this.$ga.event("ecommerce", "begin_checkout");
        this.initialize();
    },
    deactivated() {
        this.channelCode = "";
        this.shipCost = "";
        this.insure = "";
    },
};
</script>

<style lang="scss">
.shipping-container {
    padding: 15px 30px 110px;
    width: 100%;
    // height: 100%;
    box-sizing: border-box;
    text-align: left;
    .shipping-title {
        font-size: 30px;
        font-weight: 600;
        letter-spacing: 1px;
    }
    .shipping-address-items {
        display: flex;
        flex-wrap: wrap;
        .shipping-address-item {
            position: relative;
            width: 300px;
            min-height: 160px;
            overflow: hidden;
            padding: 16px 8px 8px 16px;
            box-sizing: border-box;
            border: 2px solid $color-primary;
            font-size: 12px;
            color: $color-808080;

            .el-button {
                position: absolute;
                right: 10px;
                bottom: 10px;
                padding: 4px 6px;
                min-width: 50px;
            }
            .shipping-address-item-label {
                color: $color-333333;
                & + .shipping-address-item-label {
                    margin-top: 12px;
                }
            }
            .shipping-address-item-placeholder {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 12px;
                white-space: nowrap;
            }
            & + .shipping-address-item {
                margin-left: 20px;
            }
        }
    }
    .shipping-tipbar,
    .ioss-tipbar,
    .coupon-tipbar,
    .insure-tipbar {
        background-color: #f3f3f3;
        padding: 8px 20px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 26px;
        font-size: 13px;
        color: $color-333333;
        margin: 20px 0;
        a {
            font-weight: 800;
        }
        i {
            font-weight: 600;
            font-size: 12px;
            // margin-left: 5px;
            color: $color-primary;
            &::before {
                position: relative;
                left: 8px;
            }
        }
    }
    .shipping-methods,
    .ioss-list,
    .coupon-list,
    .insure-list {
        display: table;
        flex-wrap: wrap;
        padding: 5px;
        border: 1px solid transparent;
        &-item {
            &:not(:last-child) {
                margin-bottom: 15px;
            }
        }
        &-price {
            min-width: 80px;
            display: inline-block;
            text-align: center;
        }
        &-name {
            font-weight: 600;
            margin: 0 25px;
            display: inline-block;
        }
    }
    .shipping-methods {
        &-name {
            width: 160px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .coupon-list {
        &-name {
            width: 84px;
        }
        &-price {
            text-align: left;
            padding: 0 0 0 20px;
        }
    }
    .table-wrapper {
        margin: 30px 0 40px;
        .header-cell-class-name {
            background-color: transparent;
            font-size: 14px;
            color: $color-333333 !important;
        }
        .cell-class-name {
            vertical-align: top;
            font-size: 14px;
            .el-input-number {
                width: 120px;
            }
            .el-icon-delete {
                font-size: 20px;
                cursor: pointer;
                &:active {
                    opacity: 0.6;
                }
            }
        }
        .goods-info-wrapper {
            display: flex;
            .el-image {
                width: 100px;
                height: 100px;
                flex-shrink: 0;
                & + .el-image {
                    margin-left: 5px;
                }
            }
            .info-wrapper {
                margin-left: 20px;
                font-size: 13px;
                .goods-name {
                    // width: 75%;
                    color: $color-333333;
                    margin-bottom: 10px;
                }
                .sku,
                .attr-value {
                    & span:first-of-type {
                        color: $color-333333;
                        margin-right: 10px;
                    }
                    color: #000000;
                }
                .goods-attribute {
                    // margin-top: 5px;
                    font-size: 13px;
                    display: flex;
                    color: $color-333333;
                    .goods-attribute-label {
                        margin-right: 10px;
                        flex-shrink: 0;
                    }
                    .goods-attribute-value {
                        color: #000000;
                    }
                }
                .photo_set {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-around;
                    /* & + .el-image {
                    margin-left: 5px;
                } */
                }
            }
        }
    }

    .el-scrollbar {
        .el-scrollbar__wrap {
            overflow: hidden;
            overflow-y: scroll;
        }
    }
    .bottom-bar {
        position: fixed;
        width: calc(100% - 201px);
        bottom: 0;
        right: 0;
        height: 85px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        background-color: #f6f6f7;
        z-index: 100;
        padding: 0 40px 0 20px;
        box-sizing: border-box;
        .discount,
        .subtotal,
        .total {
            font-size: 16px;
            display: flex;
            justify-content: space-between;
            font-weight: 600;
            &-label {
                color: $color-808080;
                margin-right: 20px;
            }
            &-value {
                color: #d53e3e;
            }
        }
        .discount {
            margin: 0 30px 0 0;
        }
        .total {
            font-size: 18px;
            margin: 0 30px 0 20px;
            .total-label {
                color: $color-333333;
                margin-right: 20px;
            }
        }
        .checkout-btn {
            width: 320px;
            z-index: 100;
            display: flex;
            align-items: center;
            justify-content: center;

            .el-button {
                width: 100%;
                height: 50px;
                // border-radius: 4px;
                background-color: $color-primary;
                text-align: center;
                cursor: pointer;
                color: #ffffff;
                button {
                    color: #fff;
                    font-size: 16px;
                    border: none;
                    outline: none;
                    background-color: transparent;
                }
                &:hover {
                    opacity: 0.95;
                }
                &:active {
                    opacity: 0.85;
                }
            }
        }
    }
}
.insure_tooltip {
    width: auto;
    max-width: 300px;
}
</style>
